import { Divider, Row } from "antd";
import { NavLink } from "react-router-dom";

import { useTranslation } from "react-i18next";

export function Help() {
    const { t } = useTranslation();
    return (
        <Row style={{ width: "100%" }}>
            <div className="borderBox">
                <div style={{ padding: 40 }}>
                    <div>
                        <div className="tenantHelpTitle"><img src="../images/icon_operation@2x.svg" className="tenantHelpIcon"></img>{t("操作和使用")}</div>
                        <Row style={{ marginTop: 21, marginLeft: 21 }}>
                            <a className="tenantHelpColBox bgBox" style={{ backgroundImage: "url(../images/helpCol1.png)" }} href="#" target="blank">
                                <a style={{ color: "#ffffff" }} >{t("使用手册")}</a>
                            </a>
                            <NavLink className="tenantHelpColBox bgBox" style={{ backgroundImage: "url(../images/helpCol2.png)" }} to="/helpFAG">
                                <a style={{ color: "#ffffff" }}  >{t("常见问题")}</a>
                            </NavLink>
                        </Row>
                        <Divider />
                    </div>
                    <div>
                        <div className="tenantHelpTitle">
                            <img src="../images/icon_clause@2x.svg" className="tenantHelpIcon"></img>
                            {t("条款和声明")}
                        </div>
                        <Row style={{ marginTop: 21, marginLeft: 21 }}>
                            <a className="tenantHelpColBox bgBox" style={{ backgroundImage: "url(../images/helpCol3.png)" }} href="#" target="blank">
                                <a style={{ color: "#ffffff" }} >{t("使用条款")}</a>
                            </a>
                            <a className="tenantHelpColBox bgBox" style={{ backgroundImage: "url(../images/helpCol4.png)" }} href="#" target="blank">
                                <a style={{ color: "#ffffff" }}>{t("隐私申明")}</a>
                            </a>
                        </Row>
                        <Divider />
                    </div>
                    <div>
                        <div className="tenantHelpTitle"><img src="../images/icon_contact@2x.svg" className="tenantHelpIcon" />{t("联系我们")}</div>
                        <div className="tenantHelpContact">
                            <p>{t("邮箱")}：mdm@willingtek.com</p>
                            <p>{t("时间")}：{t("工作日")} 9:00-18:00</p>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
    )
}